import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dtwin-rule-edit"
  }, [_vm.geoFences.length === 0 ? [_c(VBtn, {
    class: 'v-btn-x px-3 mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
    attrs: {
      "disabled": _vm.disabled,
      "color": _vm.color,
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('add-geo-fence', 0);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("fal fa-plus")]), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.addButton')) + "\n    ")], 1)] : [_c('p', {
    staticClass: "card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.description'))
    }
  }), _vm._l(_vm.geoFences, function (geoFence, i) {
    return _c('core-n20Card', {
      key: `geofence_${i}`,
      class: `dt-card-text-01 ${i === 0 ? 'mt-12' : ''}`,
      scopedSlots: _vm._u([{
        key: "buttons",
        fn: function () {
          return [!_vm.disabled ? _c(VBtn, {
            class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.delete'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('delete-geo-fence', i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-trash-alt")])], 1) : _vm._e(), !_vm.disabled ? _c(VBtn, {
            class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.addButton'),
              "icon": "",
              "info": "",
              "fab": "",
              "text": ""
            },
            on: {
              "click": function ($event) {
                return _vm.$emit('add-geo-fence', i);
              }
            }
          }, [_c(VIcon, {
            attrs: {
              "dark": ""
            }
          }, [_vm._v("fal fa-plus")])], 1) : _vm._e()];
        },
        proxy: true
      }], null, true)
    }, [_c(VRow, {
      attrs: {
        "align": "top"
      }
    }, [_c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4"
      }
    }, [_c('core-dtwin-finder', {
      ref: `twin-zone-finder-${i}`,
      refInFor: true,
      attrs: {
        "objectFilter": _vm.geoFenceFilter,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.twinFinderLabel'),
        "placeholder": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.twinFinderLabel'),
        "requiredErrorText": _vm.$i18n_t('IS.FM.Ticket.twinRequired'),
        "loadFullDtwinData": "",
        "hideDetails": "auto",
        "required": ""
      },
      model: {
        value: geoFence.twinId,
        callback: function ($$v) {
          _vm.$set(geoFence, "twinId", $$v);
        },
        expression: "geoFence.twinId"
      }
    })], 1), _c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4"
      }
    }, [_c(VSelect, {
      staticClass: "required",
      staticStyle: {
        "font-size": "14px"
      },
      attrs: {
        "outlined": _vm.inpOutlined,
        "color": _vm.color,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.modeLabel'),
        "items": [{
          value: 'enter',
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.modes.enter')
        }, {
          value: 'exit',
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.modes.exit')
        }, {
          value: 'dwelltime',
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.modes.dwelltime')
        }, {
          value: 'dwelltime_out',
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.modes.dwelltime_out')
        }, {
          value: 'proximity_closing',
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.modes.proximity_closing')
        }, {
          value: 'proximity_movingout',
          text: _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.modes.proximity_movingout')
        }],
        "rules": _vm.requiredRule,
        "item-text": "text",
        "item-value": "value",
        "hide-details": ""
      },
      model: {
        value: geoFence.mode,
        callback: function ($$v) {
          _vm.$set(geoFence, "mode", $$v);
        },
        expression: "geoFence.mode"
      }
    })], 1), geoFence.mode && geoFence.mode.startsWith('proximity') ? _c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.distance'),
        "rules": _vm.distanceRules,
        "hint": geoFence.proximity === 69 ? 'Nice' : null,
        "persistent-hint": "",
        "hide-details": "auto"
      },
      model: {
        value: geoFence.proximity,
        callback: function ($$v) {
          _vm.$set(geoFence, "proximity", _vm._n($$v));
        },
        expression: "geoFence.proximity"
      }
    })], 1) : _vm._e(), geoFence.mode && geoFence.mode.startsWith('dwelltime') ? _c(VCol, {
      staticClass: "py-0",
      attrs: {
        "cols": "12",
        "md": "6",
        "lg": "4"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.ruleModeler.geoFences.duration'),
        "rules": _vm.hourRules,
        "hide-details": "auto"
      },
      model: {
        value: geoFence.dwelltimeHours,
        callback: function ($$v) {
          _vm.$set(geoFence, "dwelltimeHours", _vm._n($$v));
        },
        expression: "geoFence.dwelltimeHours"
      }
    })], 1) : _vm._e()], 1)], 1);
  })]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };